import AddressBook from '@gef-ui/material-icons/AddressBook';
import BellRegular from '@gef-ui/material-icons/BellRegular';
import Camera from '@gef-ui/material-icons/Camera';
import ChartColumn from '@gef-ui/material-icons/ChartColumn';
import Clipboard from '@gef-ui/material-icons/Clipboard';
import ClipboardListCheck from '@gef-ui/material-icons/ClipboardListCheck';
import ClockFive from '@gef-ui/material-icons/ClockFive';
import EllipsisStrokeVertical from '@gef-ui/material-icons/EllipsisStrokeVertical';
import FileExclamation from '@gef-ui/material-icons/FileExclamation';
import FileUser from '@gef-ui/material-icons/FileUser';
import Fire from '@gef-ui/material-icons/Fire';
import Gear from '@gef-ui/material-icons/Gear';
import LockOpenRegular from '@gef-ui/material-icons/LockOpenRegular';
import MagnifyingGlass from '@gef-ui/material-icons/MagnifyingGlass';
import Megaphone from '@gef-ui/material-icons/Megaphone';
import Messages from '@gef-ui/material-icons/Messages';
import PhoneArrowUpRight from '@gef-ui/material-icons/PhoneArrowUpRight';
import TableLayout from '@gef-ui/material-icons/TableLayout';
import UserGroupRegular from '@gef-ui/material-icons/UserGroupRegular';
import UserHeadsetRegular from '@gef-ui/material-icons/UserHeadsetRegular';
import WrenchSimple from '@gef-ui/material-icons/WrenchSimple';
import CzpLogoPrimaryBox from '@gef-ui/material-product-logos-2023/CzpLogoPrimaryBox';
import HugoLogoPrimaryBox from '@gef-ui/material-product-logos-2023/HugoLogoPrimaryBox';
import IspLogoPrimaryBox from '@gef-ui/material-product-logos-2023/IspLogoPrimaryBox';
import LisaLogoPrimaryBox from '@gef-ui/material-product-logos-2023/LisaLogoPrimaryBox';
import PkLogoPrimaryBox from '@gef-ui/material-product-logos-2023/PkLogoPrimaryBox';
import PohledávkyLogoPrimaryBox from '@gef-ui/material-product-logos-2023/PohledávkyLogoPrimaryBox';
import SanMarcoLogoPrimaryBox from '@gef-ui/material-product-logos-2023/SanMarcoLogoPrimaryBox';

import { LINK_TYPE } from 'constants/general';
import PAGES from 'constants/pages';
import * as acls from 'features/common/acl/constants';
import campaigns from 'features/views/campaignDashboards/campaigns';
// pages stuff imports
import campaignsListFilter from 'features/views/campaignList';
import contactHistory from 'features/views/contactHistory';
import contactList from 'features/views/contactList';
import { startupDashboard } from 'features/views/dashboard/actions';
import marketPlace from 'features/views/marketPlace';
import { quickFilter } from 'features/views/marketPlace/constants';
import policyOverview from 'features/views/policyOverview';
import producedProduction from 'features/views/production/common';
import { initProductionControl } from 'features/views/productionControl/selectionCriteria/actions';
import { fetchRAAnalysis, resetFormCriteria } from 'features/views/roboAdvisory/actions';
import semaphore from 'features/views/semaphore';
import settings from 'features/views/settings';
import { startupTaskCreatingPages } from 'features/views/taskCreatingPages/actions';
import {
	BACKOFFICE_FORM_NAME,
	CONTACT_CLIENT_FORM_NAME,
	MANUAL_LEAD_FORM_NAME,
	MOBILE_SCAN_FORM_NAME,
	SELLER_REQUEST_FORM_NAME,
} from 'features/views/taskCreatingPages/form';
import taskOverview from 'features/views/taskOverview';
import unlockedClients from 'features/views/unlockedClients';
import userContext from 'features/views/userContext';
import usersSubordinate from 'features/views/usersSubordinate';

const configCP = [
	{
		link: 'dashboard',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:dashboard',
		icon: <TableLayout />,
		// two types of dashboards - further logic in checkRole fn
		aclItems: acls.DASHBOARD_ACLS,
		activeFor: ['dashboard'],
		onClick: [startupDashboard()],
		screenId: [PAGES.dashboard.id, PAGES.dashboardManager.id],
	},
	{
		link: 'campaigns',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:campaigns',
		icon: <Megaphone />,
		aclItems: acls.KCL_ACCESS_TO_KANCELAR,
		activeFor: ['campaigns'],
		onClick: [campaigns.actions.resetCriteria()],
		screenId: [PAGES.campaignOverview.id],
	},
	{
		link: 'campaignsListSettings',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:campaignSettings',
		icon: <WrenchSimple />,
		aclItems: acls.KMP_CAMPAIGN_SETTINGS,
		activeFor: ['campaignsListSettings', 'campaignSettings'],
		onClick: [campaignsListFilter.actions.resetCriteria()],
		screenId: [PAGES.campaignList.id],
	},
	{
		link: 'campaignsListManagement',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:campaignManagement',
		icon: <ClockFive />,
		aclItems: acls.KMP_DISTRIBUTE_CONTACTS,
		activeFor: ['campaignsListManagement', 'campaignManagement'],
		onClick: [campaignsListFilter.actions.resetCriteria()],
		screenId: [PAGES.campaignList.id],
	},
	{
		link: 'contacts',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:contacts',
		icon: <AddressBook />,
		aclItems: acls.KMP_DISPLAY_CAMPAIGN_OVERVIEW,
		activeFor: ['contacts', 'contactDetail'],
		onClick: [contactList.actions.startupContacts()],
		screenId: [PAGES.contacts.id],
	},
	{
		link: 'marketPlace',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:marketPlace',
		icon: <Fire />,
		aclItems: acls.MPU_DISPLAY_LEAD_LIST,
		activeFor: ['marketPlace', 'leadDetail'],
		onClick: [
			marketPlace.actions.fetchAvailableMarketLeads(),
			marketPlace.actions.fetchQuickFilterLeads(quickFilter.CURRENT),
		],
		screenId: [PAGES.marketPlace.id],
	},
	{
		link: 'tasks',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:tasks',
		icon: <Clipboard />,
		aclItems: acls.MPU_DISPLAY_TASK_LIST,
		activeFor: ['tasks', 'taskSearch', 'detail', 'statistics', 'printNein'],
		onClick: [taskOverview.actions.fetchTaskTypeList()],
		screenId: [PAGES.tasksOverview.id],
	},
	{
		link: 'requestForSeller',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:requestForSeller',
		icon: <ClipboardListCheck />,
		aclItems: acls.MPU_CREATE_MANUAL_TASK,
		activeFor: ['requestForSeller'],
		onClick: [startupTaskCreatingPages(SELLER_REQUEST_FORM_NAME)],
		screenId: [PAGES.taskCreatingPages.sellerRequest.id],
	},
	{
		link: 'contactClient',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:contactClient',
		icon: <PhoneArrowUpRight />,
		aclItems: acls.MPU_CREATE_CONTACTCLIENT_TASK,
		activeFor: ['contactClient'],
		onClick: [startupTaskCreatingPages(CONTACT_CLIENT_FORM_NAME)],
		screenId: [PAGES.taskCreatingPages.contactClient.id],
	},
	{
		link: 'manualLead',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:manualLead',
		icon: <BellRegular />,
		aclItems: acls.MPU_CREATE_LEAD,
		activeFor: ['manualLead'],
		onClick: [startupTaskCreatingPages(MANUAL_LEAD_FORM_NAME)],
		screenId: [PAGES.taskCreatingPages.manualLead.id],
	},
	{
		link: 'mobileScanning',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:mobileScanning',
		icon: <Camera />,
		activeFor: ['mobileScanning'],
		aclItems: acls.MPU_CREATE_MOBILE_SCANNING_TASK,
		onClick: [startupTaskCreatingPages(MOBILE_SCAN_FORM_NAME)],
		screenId: [PAGES.taskCreatingPages.mobileScanning.id],
	},
	{
		link: 'backoffice',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:backoffice',
		icon: <UserHeadsetRegular />,
		activeFor: ['backoffice'],
		aclItems: acls.MPU_CREATE_BACKOFFICE_TASK,
		onClick: [startupTaskCreatingPages(BACKOFFICE_FORM_NAME)],
		screenId: [PAGES.taskCreatingPages.backOffice.id],
	},
	{
		link: 'kopr',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:kopr',
		icon: <FileExclamation />,
		activeFor: ['kopr', 'koprDetail'],
		aclItems: acls.KCL_DISPLAY_DOCUMENT_CHECK,
		onClick: [initProductionControl()],
		screenId: [PAGES.productionControl.id],
	},
	{
		link: 'producedProduction',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:reportedDocuments',
		icon: <FileUser />,
		aclItems: acls.KMP_START_PRE_PRODUCTION,
		activeFor: ['producedProduction'],
		onClick: [
			producedProduction.actions.resetCriteriasAndTriggerOrgStructureRefetch(),
			producedProduction.actions.startupProducedProduction(),
		],
		screenId: [PAGES.producedProduction.id],
	},
	{
		link: 'subordinateUsers',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:subordinateUsers',
		icon: <UserGroupRegular />,
		aclItems: acls.MPU_DISPLAY_SUBUSER_LIST,
		activeFor: ['subordinateUsers'],
		onClick: [usersSubordinate.actions.startupSubordinateUsers()],
		screenId: [PAGES.subordinateUsers.id],
	},
	{
		link: 'roboAdvisory',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:roboAdvisory',
		icon: <ChartColumn />,
		aclItems: acls.KCL_DISPLAY_RA_ANALYSES,
		activeFor: ['roboAdvisory'],
		onClick: [resetFormCriteria(), fetchRAAnalysis()],
		screenId: [PAGES.roboAdvisory.id],
	},
	{
		link: 'policyOverview',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:contractOverview',
		icon: <MagnifyingGlass />,
		aclItems: acls.KCL_DISPLAY_POLICY_LIST,
		activeFor: ['policyOverview'],
		onClick: [policyOverview.actions.resetCriteria()],
		screenId: [PAGES.policyOverview.id],
	},
	{
		link: 'semaphore',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:semaphore',
		icon: <EllipsisStrokeVertical />,
		aclItems: acls.KCL_DISPLAY_SEMAPHORE,
		activeFor: ['semaphore'],
		onClick: [semaphore.actions.resetFormCriteria()],
		screenId: [PAGES.semaphore.id],
	},
	{
		link: 'contactHistory',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:contactHistory',
		icon: <Messages />,
		aclItems: acls.KCL_DISPLAY_CONTACT_HISTORY,
		activeFor: ['contactHistory'],
		onClick: [contactHistory.actions.resetCriteria()],
		screenId: [PAGES.contactHistory.id],
	},
	{
		link: 'unlockedClients',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:unlockedClients',
		icon: <LockOpenRegular />,
		aclItems: acls.KCL_DISPLAY_UNLOCKED_CLIENTS,
		activeFor: ['unlockedClients'],
		onClick: [unlockedClients.actions.resetFormCriteria()],
		screenId: [PAGES.unlockedClients.id],
	},
	{
		link: 'settings',
		linkType: LINK_TYPE.LOCAL,
		label: 'leftMenu:settings',
		icon: <Gear />,
		aclItems: acls.KCL_DISPLAY_SETTINGS,
		activeFor: ['settings'],
		onClick: [userContext.actions.reset(), settings.actions.fetchNotificationSettings({ resetEmailForm: true })],
		screenId: [PAGES.settings.notificationSending.id],
	},
	{
		link: 'HUGO',
		linkType: LINK_TYPE.EXTERNAL,
		label: 'leftMenu:hugo',
		icon: <HugoLogoPrimaryBox />,
		activeFor: [],
		aclItems: acls.KCL_DASHBOARD_HUGO,
	},
	{
		link: 'CZP',
		linkType: LINK_TYPE.EXTERNAL,
		label: 'leftMenu:czp',
		icon: <CzpLogoPrimaryBox />,
		activeFor: [],
		aclItems: acls.KCL_DASHBOARD_CZP,
	},
	{
		link: 'DEBTS',
		linkType: LINK_TYPE.EXTERNAL,
		label: 'leftMenu:debts',
		icon: <PohledávkyLogoPrimaryBox />,
		activeFor: [],
		aclItems: acls.KCL_DASHBOARD_DEBTS,
	},
	{
		link: 'PK',
		linkType: LINK_TYPE.EXTERNAL,
		label: 'leftMenu:pkCp',
		icon: <PkLogoPrimaryBox />,
		activeFor: [],
		aclItems: acls.KCL_DASHBOARD_PK,
	},
	{
		link: 'ISP',
		linkType: LINK_TYPE.EXTERNAL,
		label: 'leftMenu:ispCp',
		icon: <IspLogoPrimaryBox />,
		activeFor: [],
		aclItems: acls.KCL_DASHBOARD_ISP,
	},
	{
		link: 'LISA',
		linkType: LINK_TYPE.EXTERNAL,
		label: 'leftMenu:lisa',
		icon: <LisaLogoPrimaryBox />,
		activeFor: [],
		aclItems: acls.KCL_DASHBOARD_LISA,
	},
	{
		link: 'LISA2',
		linkType: LINK_TYPE.EXTERNAL,
		label: 'leftMenu:lisa2',
		icon: <LisaLogoPrimaryBox />,
		activeFor: [],
		aclItems: acls.KCL_DASHBOARD_LISA2,
	},
	{
		link: 'SAN_MARCO',
		linkType: LINK_TYPE.EXTERNAL,
		label: 'leftMenu:sanMarco',
		icon: <SanMarcoLogoPrimaryBox />,
		activeFor: [],
		aclItems: acls.KCL_DASHBOARD_SANMARCO,
	},
];

export default configCP;
